
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWave as ObiWaveElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wave.js';
 
 
 

 
 export const ObiWave = createComponent({
   react: React,
   tagName: 'obi-wave',
   elementClass: ObiWaveElement,
   events: {
     
   }
  });
 
 